import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, Type} from "@angular/core";
import {FUIStackedPageService} from "@fedeltapointofsale/ui";
import {ExtendedSearchParams, SearchType} from "../../../../search/search-page/extended-search-params";
import {Subscription} from "rxjs";
import {AddRowActionComponent} from "./add-row-action.component";
import {EditGridAddRowSearchSelectResults, EditGridAddRowService} from "../edit-grid-add-row.service";
import {AnalyticsService} from "../../../../../../analytics/analytics.service";
import {AnalyticEvent} from "../../../../../../analytics/analytic-event";
import {RoutingDiscoveryService} from "../../../../../../routing-discovery.service";

@Component({
    selector: "wbo-edit-grid-add-row-search",
    template: "",
    providers: [
        {provide: AddRowActionComponent, useExisting: forwardRef(() => EditGridAddRowSearchComponent), multi: true}
    ]
})
export class EditGridAddRowSearchComponent extends AddRowActionComponent implements OnInit, OnDestroy {
    @Input() searchComponent: Type<any>;
    @Input() searchPath: string;
    @Input() searchType: SearchType = SearchType.MULTIPLE_SELECTION;
    @Input() searchParams: any;
    @Input() customAdd: boolean = false;

    @Output() onSelect: EventEmitter<EditGridAddRowSearchSelectResults> = new EventEmitter<EditGridAddRowSearchSelectResults>();

    @Input() title: string = "wbo.edit.grid.add.addExisting";

    private subscriptions: Subscription = new Subscription();

    constructor(private stackedPageService: FUIStackedPageService,
                private routingDiscoveryService: RoutingDiscoveryService,
                private editGridAddRowService: EditGridAddRowService,
                private analyticsService: AnalyticsService) {
        super();
    }

    ngOnInit(): void {
        if (this.searchPath && !this.searchComponent) {
            this.searchComponent = this.routingDiscoveryService.findRoutingComponent(this.searchPath);
        }
    }

    override click(): void {
        this.search()
    }

    search(): void {
        this.subscriptions.add(this.stackedPageService.open(this.searchComponent,
            new ExtendedSearchParams(this.searchType, this.searchParams)).subscribe(results => {
            this.onSelect.next(results)
            if (!this.customAdd) {
                this.editGridAddRowService.addSearchSelect(new EditGridAddRowSearchSelectResults(results));
            }
        }));

        this.analyticsService.trackEvent(AnalyticEvent.ENTITY_INTERACTION_GRID_ADD_EXISTING);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
